<template>
  <div class='electrify'>
    <div class='nav'>
      <el-form :model='form' label-width='100px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='供应商名称:'>
          <el-input v-model='form.supplierName' size='mini' placeholder='请输入供应商名称' />
        </el-form-item>
        <el-form-item label='港口名称:'>
          <el-input v-model='form.portName' size='mini' placeholder='请输入港口名称' />
        </el-form-item>
        <el-form-item label='台账月:'>
          <el-input v-model='form.standingBookMonth' size='mini' placeholder='请输入台账月' />
        </el-form-item>
        <el-form-item label='作业类型：' prop='workType'>
          <el-select v-model='form.workType' placeholder='请选择作业类型'
                     size='mini' value-key='id'>
            <el-option label='全部' value='' />
            <el-option v-for='(item,index) in workTypeArr' :label='item.label'
                       :value='item.type' :key='index' />
          </el-select>
        </el-form-item>
        <el-form-item label='审核状态：' prop='auditType'>
          <el-select v-model='form.auditType' placeholder='请选择审核状态'
                     size='mini' value-key='id'>
            <el-option v-for='(item,index) in auditTypeArr' :label='item.label'
                       :value='item.type' :key='index' />
          </el-select>
        </el-form-item>


        <el-form-item label='是否生成对账单:' label-width='130px'>
          <el-select v-model='form.isReconciliation' filterable size='mini'
                     placeholder='请选择是否生成对账单'>
            <el-option label='全部' value=''></el-option>
            <el-option label='是' value='2'></el-option>
            <el-option label='否' value='1'></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button v-if='pageType' size='small' type='primary' @click='addBtn'>生成对账单</el-button>
          <!--          <el-button v-if='pageType' size='small' type='primary' @click='addResetBtn'>刷新结算
                    </el-button>-->
          <el-button v-if='pageType' size='small' type='primary' @click='addData(0)'>新增</el-button>
<!--          <el-button v-if='pageType' size='small' type='primary' @click='ledgerRevise'>修改台账月-->
<!--          </el-button>-->
        </el-form-item>

      </el-form>
    </div>
    <!-- 导入/导出 -->
    <el-row v-if='pageType'>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <!--       <span style='cursor: pointer;display: inline-block;'>
                <import-statement @getList='_refuelingpowerList' :type='7' />
                </span>-->
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          tooltip-effect='dark'
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :row-style="rowStyle"
          :header-cell-style="{
            color:'#3B3B3B',
            'font-size':'13px',
            'height':'48px',
            background:'#E8E8E8'
          }"
          row-key='id'
          :reserve-selection='true'
        >
          <!--<el-table-column type='expand'>

                      <template slot-scope='scope'>
                        <el-table v-if='scope.row.isDetailedList' :data='scope.row.portOtherCarList'
                                  v-loading='childrenLoading'
                                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}" stripe border
                                  style='margin: 0;padding: 0;width: 50%'>
                          <el-table-column prop='batchNumber' label='批次号' align='center' />
                          <el-table-column prop='waybillNo' label='运单编号' align='center' />
                          <el-table-column prop='frameNumber' label='车架号' align='center' />
                          <el-table-column prop='brandName' label='品牌名称' align='center' />
                          <el-table-column prop='modelName' label='型号名称' align='center' />
                        </el-table>
                      </template>
                    </el-table-column>-->
          <el-table-column type='selection' align='center' width='80px'
                           :reserve-selection='true'
                           :selectable='(row,index)=>{return row.isReconciliation !==1}' />
          <el-table-column prop='supplierName' label='供应商' align='center' min-width='150'
                           show-overflow-tooltip />
          <el-table-column prop='portName' label='港口名称' align='center' min-width='150'
                           show-overflow-tooltip />
          <el-table-column prop='standingBookMonth' label='台账月' align='center' min-width='150'
                           show-overflow-tooltip />
          <el-table-column prop='workType' label='作业类型' align='center' min-width='80px'
                           show-overflow-tooltip>
            <template slot-scope='scope'>{{ scope.row.workType|workTypeFormat }}</template>
          </el-table-column>
          <el-table-column prop='workDate' label='作业时间' align='center' min-width='120'
                           show-overflow-tooltip>
            <template slot-scope='scope'>{{ scope.row.workDate|formatTime }}</template>
          </el-table-column>
          <el-table-column prop='taskNum' label='作业数量' align='center' show-overflow-tooltip />
          <el-table-column label='消费数量' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.priceNum ? scope.row.priceNum + scope.row.unit : '--' }}
            </template>
          </el-table-column>
          <el-table-column v-if='pageType' label='税率(%)' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.auditType == 2 ? scope.row.taxRate : '--' }}
            </template>
          </el-table-column>
          <el-table-column v-if='pageType' label='含税总金额' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.auditType == 2 ? scope.row.taxTotalPrice : '--' }}
            </template>
          </el-table-column>
          <el-table-column v-if='pageType' label='不含税总金额' align='center' show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.auditType == 2 ? scope.row.totalPrice : '--' }}
            </template>
          </el-table-column>

          <el-table-column v-if='pageType' prop='isReconciliation' label='是否生成对账单' align='center'>
            <template slot-scope='scope'>{{ scope.row.isReconciliation|isGenerateBillFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='auditType' label='审核状态' align='center'>
            <template slot-scope='scope'>{{ scope.row.auditType|auditFormat }}
            </template>
          </el-table-column>
          <el-table-column label='操作' min-width='270' align='center'>
            <template slot-scope='scope'>
              <div style='display:flex;align-items:center;justify-content: space-evenly'>
                <el-button size='mini' class='searchBtn' type='primary'
                           @click='detailClick(scope.row.id)'>详情
                </el-button>
                <el-button v-if='scope.row.auditType!=2 && pageType' size='mini' class='yellow-bg'
                           type='primary'
                           @click='changeClick(scope.row.id)'>修改
                </el-button>
                <el-button v-else-if='scope.row.choise && scope.row.auditType === 1' size='mini'
                           type='primary'
                           @click='auditClick(scope.row.id,1)'>同意
                </el-button>
                <el-button v-if='scope.row.auditType!=2 && pageType' size='mini' type='danger'
                           @click='delClick(scope.row.id)'>删除
                </el-button>
                <el-button v-else-if='scope.row.choise && scope.row.auditType === 1' size='mini'
                           type='danger'
                           @click='auditClick(scope.row.id,0)'>拒绝
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[50, 100, 500, 1000,5000]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <!-- 对账单 -->
    <el-dialog
      :title="importShow ? '导入生成对账单' : '生成对账单'"
      :visible.sync='addFlag'
      width='950px'
      center
      @close='dialogClose'>
      <electrify-account
        @closeDialogAndSearch='closeDialogAndSearch'
        :import-show='importShow'
        ref='accountState'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单信息</template>
        <template slot='label3'>其他费用</template>
      </electrify-account>

    </el-dialog>
    <el-dialog title='添加其他费用' :visible.sync='otherAddFlag' append-to-body width='750px'>
      <otherAdd @otherDataCelect='otherData' ref='otherAdds'
                :otherDateProps='JSON.parse(JSON.stringify(otherTableData))'
                :consignor-id='consignorId'></otherAdd>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' width='1100px' center
               @close='dialogShut' :close-on-click-modal='false'>
      <div class='add' v-loading='detailLoading'>
        <div class='baseInfo'>

          <div class='baseInfoContent'>

            <el-form :model='addFormData' label-width='110px' label-position='right'
                     :rules='addRules'
                     ref='addForm' class='demo-addForm'>
              <div-border label='基础信息' prop='plan'>
                <div class='yang'>
                  <el-row>
                    <el-col :span='12'>
                      <el-form-item label='港口名称：' prop='portId'>
                        <el-select :disabled="dialogTitle === '详情'" v-model='addFormData.portId'
                                   filterable placeholder='请选择港口'
                                   size='mini' value-key='id'>
                          <el-option v-for='item in portOption' :key='item.id'
                                     :label='item.supplier_name' :value='item.id' />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                      <el-form-item label='作业类型：' prop='workType'>
                        <el-select
                          :disabled="dialogTitle === '详情'" v-model='addFormData.workType'
                          filterable placeholder='请选择作业类型'
                          size='mini' value-key='id' @change='changUnit'>
                          <el-option v-for='(item,index) in workTypeArr' :label='item.label'
                                     :value='item.type' :key='index' />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                      <el-form-item label='作业时间：' prop='workDate'>
                        <el-date-picker
                          :disabled="dialogTitle === '详情'"
                          v-model='addFormData.workDate'
                          type='datetime'
                          size='mini'
                          value-format='yyyy-MM-dd HH:mm:ss'
                          placeholder='请选择作业时间'>
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                      <el-form-item label='作业车数量：' prop='taskNum'>
                        <el-input
                          :disabled="dialogTitle === '详情'"
                          placeholder='请输入作业车数量'
                          v-model='addFormData.taskNum' size='mini'>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                      <el-form-item label='税率：' prop='taxRate'>
                        <el-input
                          :disabled="dialogTitle === '详情'"
                          type='number'
                          placeholder='请输入税率'
                          v-model='addFormData.taxRate' size='mini'>
                          <template slot='append'>%</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                      <el-form-item label='含税总金额：' prop='taxTotalPrice'>
                        <el-input
                          :disabled="dialogTitle === '详情'"
                          type='number'
                          placeholder='请输入含税总金额'
                          v-model='addFormData.taxTotalPrice' size='mini'>
                          <template slot='append'>元</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span='12'>
                      <el-form-item
                        v-if='!(addFormData.workType === "" ||addFormData.workType === 1 || addFormData.workType === 5)'
                        label='消费数量：' prop='priceNum'>
                        <el-input
                          :disabled="dialogTitle === '详情'"
                          type='number'
                          placeholder='请输入消费数量'
                          v-model='addFormData.priceNum' size='mini'>
                          <template slot='append'>{{ unit }}</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>


                </div>
              </div-border>
              <!--<div-border label='作业车信息' prop='info'>
                              <div class='nav'>
                                <el-form v-if="dialogTitle!=='详情'" :model='dialogForm' label-width='100px'
                                         :inline='true'
                                         class='demo-form-inline flex1 dialogForm'>
                                  <el-form-item label='运单号：'>
                                    <el-input v-model='dialogForm.waybillNo' size='mini'
                                              placeholder='请输入运单号' />
                                  </el-form-item>
                                  <el-form-item label='车架号：'>
                                    <el-input v-model='dialogForm.frameNumber' size='mini'
                                              placeholder='请输入车架号' />
                                  </el-form-item>
                                  <el-form-item>
                                    <el-button size='small' class='searchBtn' @click='addDialogTable'>添加
                                    </el-button>
                                  </el-form-item>
                                </el-form>
                              </div>
                              <el-table
                                :data='dialogData'
                                style='width: 100%;margin: 10px 0'
                                border
                                :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                              >
                                <el-table-column prop='batchNumber' label='批次号' min-width='150'
                                                 show-overflow-tooltip
                                                 align='center' />
                                <el-table-column prop='waybillNo' label='运单号' min-width='150'
                                                 show-overflow-tooltip
                                                 align='center' />
                                <el-table-column prop='frameNumber' label='车架号' min-width='150'
                                                 show-overflow-tooltip
                                                 align='center' />
                                <el-table-column prop='brandName' label='品牌' min-width='150'
                                                 show-overflow-tooltip
                                                 align='center' />
                                <el-table-column prop='modelName' label='型号' min-width='150'
                                                 show-overflow-tooltip
                                                 align='center' />

                                <el-table-column v-if="dialogTitle!=='详情'" label='操作' align='center'>
                                  <template slot-scope='scope'>
                                    <i class='el-icon-error' style='font-size: 20px;'
                                       @click='delDialogData(scope.$index)'></i>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </div-border>-->
              <div-border v-if="dialogTitle === '详情'" label='审核信息' prop='examine'>
                <steps class='dialogForm' :step-data='stepData' :step-state='stepState' />
              </div-border>
              <div-border v-if="dialogTitle === '详情'" label='操作记录' prop='operationRecord'>
                <el-table
                  :data='detailData'
                  style='width: 100%;margin: 10px 0'
                  border
                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}">
                  <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
                  <el-table-column prop='operateType' label='操作类型' align='center' />
                  <el-table-column prop='operationName' label='操作人' align='center' />
                  <el-table-column prop='remark' label='备注' align='center' />
                </el-table>
              </div-border>
            </el-form>
            <div class='btnContainer' v-if="dialogTitle!=='详情'">
              <el-button size='medium' class='searchBtn' :loading='addLoad' @click='addOrEdit'>
                确定
              </el-button>
              <el-button size='medium' class='resetBtn' @click='dialogShut'>关闭</el-button>
            </div>
          </div>

        </div>

      </div>
    </el-dialog>
    <!-- 修改台账月 -->
    <el-dialog title='修改台账月' :visible.sync='ledgerVisible' width='750px' center
               @close='ledgerClose'>
      <div class='ledger'>
        <div class='leader-input'>
          <span>请输入台账月：</span>
          <el-input style='display:inline-block' size='small' type='text' v-model='ledger' />
          <div style='display:inline-block;width:calc(100% - 300px);text-align:right'>
            <el-button size='small' class='searchBtn' @click='ledgerChange'>确 定</el-button>
            <el-button size='small' class='resetBtn' @click='ledgerClose'>取 消</el-button>
          </div>
        </div>
        <el-table
          v-loading='ledgerLoad'
          :data='ledgerData'
          style='width: 100%'
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column prop='supplierName' label='供应商名称' min-width='150' show-overflow-tooltip
                           align='center' />
          <el-table-column prop='portName' label='港口名称' min-width='150' show-overflow-tooltip
                           align='center' />
          <el-table-column prop='standingBookMonth' label='台账月' min-width='150'
                           show-overflow-tooltip
                           align='center' />
          <el-table-column label='作业类型' min-width='100' show-overflow-tooltip
                           align='center'>
            <template slot-scope='scope'>
              {{ scope.row.workType|workTypeFormat }}
            </template>
          </el-table-column>
          <el-table-column prop='modelName' label='作业时间' min-width='100' show-overflow-tooltip
                           align='center'>
            <template slot-scope='scope'>
              {{ scope.row.workDate|formatTime }}
            </template>
          </el-table-column>
          <el-table-column label='操作' width='60px' align='center'>
            <template slot-scope='scope'>
              <i class='el-icon-error' style='font-size: 20px;'
                 @click='delLedger(scope.$index)'></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog :title='reasonTitle' :visible.sync='reasonVisible' width='550px' center
               :close-on-click-modal='false' top='30vh'>
      <div class='reasonContainer'>
        <div style='display: flex;padding-bottom: 20px;'>
          <span class='span1' style='width: 70px;'><span style='color:red'>*</span>原因：</span>
          <el-input
            type='textarea'
            style='width:100%;'
            v-model='reason'
            placeholder='请填写同意/拒绝原因'
            autocomplete='off'
            size='small'
          />
        </div>
        <div class='reasonBtn'>
          <el-button size='medium' class='searchBtn' type='primary' @click='reasonClick'>确认
          </el-button>
          <el-button size='medium' class='resetBtn' type='danger' @click='reasonVisible=false'>取消
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    deductionInvoicingCostGetAllByCompanyId,
    refuelingpowerList,
    auditPageList,
    refuelingpowerVehicleAllListById,
    customerAdd,
    addTableData,
    addCost,
    updateCost,
    delCost,
    dialogInfo,
    refreshSettlement,
    updateStandingBook,
  } from '@/service/getData';
  import { supplierPublicSelectPort } from '@/service/vehiclelog';
  import { formatTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder.vue';
  import steps from '@/components/steps.vue';
  import { auditFuelCost } from '@/service/audit';
  import electrifyAccount from '@/views/settle/supplier/components/electrifyAccount.vue';
  import otherAdd from './otherAdd.vue';
  import { baseUrl } from '@/config/env';
  import ImportStatement from '@/views/settle/entrust/components/import-statement';

  export default {
    components: {
      ImportStatement,
      otherAdd,
      divBorder,
      steps,
      electrifyAccount,
    },

    data() {
      return {
        form: {
          supplierName: '', // 供应商名称
          portName: '', // 港口名称
          standingBookMonth: '', // 台账月
          workType: '', // 作业类型
          auditType: '', // 审核状态
          isReconciliation: '', // 是否生成账单
          page: 1,
          rows: 50,
        },
        total: 0,
        tableLoad: false,
        childrenLoading: false,
        TableDatas: [],
        checkList: [], // 导入生成账单 选择数据
        visible: false, // 导入生成账单 筛选条件显示
        settlement: '', // 生成对账单时的结算方式

        importShow: false,
        activeName: 'information', // 标签页
        otherAddFlag: false,
        isDisabled: false, // 是否启用合同价
        consignorId: '', // 公司id
        InvoicingList: [], // 抵扣费用下拉
        informationData: {
          supplier: '', // 供应商
          sumIncluded: '', // 合计含税费用
          sumNotIncluded: '', // 合计不含税费用
          title: '', //
          isInvoicing: 0, // 是否抵扣开票
          Invoicing: '', // 选择抵扣费用
          Deductible: '', // 抵扣费用
          remark: '',
        },
        checkLoad: false,
        notTableData: [],
        otherTableData: [],
        checkTableData: [],
        otherIncluded: 0, // 其他费用合计
        otherNotIncluded: 0, // 其他费用合计
        sumContract: 0, // 作业费用合计
        sumNotIncluded: 0,
        oldSupplier: '', // 原供应商
        stepData: [],
        addFlag: false,
        rules: {
          title: {
            reqired: true,
            message: '请输入对账单标题',
            trigger: 'blur',
          },
          isInvoicing: {
            required: true,
            message: '请选择是否抵扣开票',
            trigger: 'blur',
          },
          Invoicing: {
            required: true,
            message: '请选择抵扣费用数据',
            trigger: 'blur',
          },
          Deductible: {
            required: true,
            message: '请输入抵扣费用',
            trigger: 'blur',
          },
          IsoilPrice: {
            required: true,
            message: '请选择是否启用油价',
            trigger: 'blur',
          },
        },
        // 新增
        dialogTitle: '新增',
        dialogVisible: false,
        detailLoading: false,
        addFormData: {
          portId: '',
          workType: '',
          workDate: '',
          taskNum: '',
          priceNum: '',
          taxRate: '',
          taxTotalPrice: '',
        },
        workTypeArr: [{
          label: '翻仓',
          type: 1,
        }, {
          label: '加油',
          type: 2,
        }, {
          label: '搭电',
          type: 3,
        }, {
          label: '加气',
          type: 4,
        }, {
          label: '洗车',
          type: 5,
        }],
        auditTypeArr: [{
          label: '全部',
          type: '',
        }, {
          label: '待审核',
          type: 1,
        }, {
          label: '已通过',
          type: 2,
        }, {
          label: '已拒绝',
          type: 3,
        }, {
          label: '已取消',
          type: 4,
        }],
        addRules: {
          portId: {
            required: true,
            message: '请选择港口',
            trigger: 'blur',
          },
          workType: {
            required: true,
            message: '请选择作业类型',
            trigger: 'blur',
          },
          workDate: {
            required: true,
            message: '请选择作业时间',
            trigger: 'blur',
          },
          taskNum: {
            required: true,
            message: '请输入作业车数量',
            trigger: 'blur',
          },
          taxRate: {
            required: true,
            message: '请输入税率',
            trigger: 'blur',
          },
          taxTotalPrice: {
            required: true,
            message: '请输入含税总金额',
            trigger: 'blur',
          },
          priceNum: {
            required: false,
          },
        },
        portOption: [], // 港口
        addLoad: false,
        dialogForm: {
          waybillNo: '', // 运单号
          frameNumber: '', // 车架号
        },
        dialogData: [],
        unit: '', // 消费数量单位
        detailData: [], // 操作记录数组
        // 修改台账月
        ledgerVisible: false,
        ledgerLoad: false,
        ledger: '',
        ledgerData: [],
        pageType: 0,
        reasonVisible: false,
        reasonTitle: '',
        reason: '',
      };
    },
    computed: {
      stepState() {
        return function(state) {
          switch (state) {
            case '':
              return 'wait';
            case 'success':
              return 'success';
            case 'failure':
              return 'error';
          }
        };
      },
    },
    watch: {
      checkTableData(val) {
        console.log(val);
        this.sumContract = this.calculation(val, 'taxPrice');

        this.sumNotIncluded = this.calculation(val, 'price');

        // 合计不/含税费用
        this.sumCost();
        //  判断 不/含税合同价是否为空  value  value2其他费用
        this.decideContract(val, this.otherTableData);
        this.informationData.supplier = this.oldSupplier = this.checkTableData.length > 0 ? this.checkTableData[0].portName : '';
      },
      otherTableData(val) {
        this.otherIncluded = this.calculation(val, 'costAmount');
        this.otherNotIncluded = this.calculation(val, 'excludingTaxAmount');
        // 合计不/含税费用
        this.sumCost();

        this.decideContract(this.checkTableData, val);
      },
    },
    filters: {
      isGenerateBillFormat(value) {
        let val = '';
        switch (value) {
          case 0:
            val = '否';
            break;
          case 1:
            val = '是';
            break;
          default:
            val = '--';
            break;
        }
        return val;
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd ');
        }
        return '';
      },
      workTypeFormat(value) {
        let type = '';
        switch (value) {
          case 1:
            type = '翻仓';
            break;
          case 2:
            type = '加油';
            break;
          case 3:
            type = '搭电';
            break;
          case 4:
            type = '加气';
            break;
          case 5:
            type = '洗车';
            break;
          default:
            type = '--';
            break;
        }
        return type;
      },
      auditFormat(value) {
        let val = '';
        switch (value) {
          case 1:
            val = '待审核';
            break;
          case 2:
            val = '已通过';
            break;
          case 3:
            val = '已拒绝';
            break;
          case 4:
            val = '已取消';
            break;
          default:
            val = '--';
            break;
        }
        return val;
      },
    },
    mounted() {
      if (this.$route.params.type === 0) {
        this.pageType = this.$route.params.type;
        this._refuelingpowerList();
      } else {
        this.pageType = 1;
      }
      console.log(this.pageType);
      this._allList();
    },
    methods: {
      init() {

      },
      // 抵扣费用下拉
      async _deductionInvoicingCostGetAllByCompanyId(id) {
        const res = await deductionInvoicingCostGetAllByCompanyId(id);
        if (res.status !== 0) return this.$message.error(res.message);
        this.InvoicingList = res.data.map(item => ({
          id: item.id,
          deductionNum: item.deduction_num,
          remainingDiscountAmount: item.remaining_discount_amount,
        }));
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/settlement/supplierPortOther/exportXls?access_token=${token}&supplierName=${this.form.supplierName}&portName=${this.form.portName}&standingBookMonth=${this.form.standingBookMonth}&workType=${this.form.workType}&auditType=${this.form.auditType}&isReconciliation=${this.form.isReconciliation}`;
      },
      // 分页查询
      async _refuelingpowerList() {
        this.tableLoad = true;
        let res = {};
        if (this.pageType) {
          res = await refuelingpowerList(this.form);
        } else {
          res = await auditPageList(this.form);
        }
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.total = res.data.total;
        this.TableDatas = res.data.records;
      },
      // 子分页查询
      async _refuelingpowerVehicleAllListById(id) {
        this.childrenLoading = true;
        const res = await refuelingpowerVehicleAllListById({ id });
        this.childrenLoading = false;
        if (res.status !== 0) return this.$message.error(res.message);
        return res.data;
      },
      compareDate(d1, d2) {
        return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
      },
      // 结束时间
      dateChange(val) {
        if (this.form.workTime[1] && this.form.workTime[0] && this.compareDate(this.form.workTime[0], this.form.workTime[1])) {
          if (val == this.form.workTime[1]) this.form.workTime[1] = '';
          if (val == this.form.workTime[0]) this.form.workTime[0] = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 合计不/含税费用
      sumCost() {
        this.informationData.sumIncluded = this.sumContract + this.otherIncluded;
        this.informationData.sumNotIncluded = this.sumNotIncluded + this.otherNotIncluded;
      },
      async _customerAdd() {
        const {
          supplier,
          sumIncluded,
          sumNotIncluded,
          title,
          isInvoicing,
          Invoicing,
          Deductible,
          remark,
          Settlement,
        } = this.informationData;
        let settIds = '';
        this.checkTableData.forEach((item, index) => {
          // 最后一个不加逗号
          settIds += index === this.checkTableData.length - 1 ? item.id : `${item.id},`;
        });
        let otherCostIds = '';
        this.otherTableData.forEach((item, index) => {
          // 最后一个不加逗号
          otherCostIds += index === this.otherTableData.length - 1 ? item.id : `${item.id},`;
        });
        const obj = {
          companyId: this.consignorId,
          companyNameOld: this.oldSupplier,
          companyNameNew: supplier,
          taxPrice: Number(sumIncluded),
          noTaxPrice: Number(sumNotIncluded),
          title,
          isDeduct: isInvoicing,
          deductId: Invoicing.id,
          deductAmount: Deductible,
          remark,
          type: 7, // 加油塔结算
          settIds: this.checkTableData.length > 0 ? settIds : '',
          otherCostIds: this.otherTableData.length > 0 ? otherCostIds : '',

          settType: this.settlement,
        };
        const res = await customerAdd(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._refuelingpowerList();
        this.dialogClose();
      },
      // 生成对账单按钮
      addBtn() {
        if (this.checkTableData.length === 0) return this.$message.warning('请至少选择一条结算数据！');
        let supplierFlag = false; // 供应商
        let taxFlag = false; // 税率
        let reconciliationFlag = false; // 是否生成对账单
        let auditFlag = false; // 审核状态
        let isSettlementFlag = false; // 是否生成结算
        if (this.checkTableData.length > 0) {
          const {
            supplierId,
            taxRate,
          } = this.checkTableData[0];
          this.checkTableData.forEach((item) => {
            if (item.supplierId !== supplierId) {
              supplierFlag = true;
            }
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
            if (item.isReconciliation) {
              reconciliationFlag = true;
            }
            if (item.auditType !== 2) {
              auditFlag = true;
            }
            if (item.isSettlement !== 1) {
              isSettlementFlag = true;
            }
          });
        }
        if (supplierFlag) return this.$message.warning('只能选择同一家供应商数据！');
        if (auditFlag) return this.$message.warning('部分数据未审核通过！');
        if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');
        if (isSettlementFlag) return this.$message.warning('部分数据未生成结算！');
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');

        this.addFlag = true;
        this.$nextTick(() => {
          // 传入表格数据
          this.$refs.accountState.init(this.checkTableData);
        });

        this.importShow = false;
      },
      // 刷新结算按钮
      async addResetBtn() {
        this.tableLoad = true;
        const {
          status,
          message,
        } = await refreshSettlement();
        this.tableLoad = false;
        status === 0 ? this.$message.success(message) : this.$message.error(message);
      },
      searchBtn() {
        this.form.page = 1;
        this._refuelingpowerList();
      },
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.workTime = ['', ''];
        this.form.page = 1;
        this.form.rows = 10;
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._refuelingpowerList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._refuelingpowerList();
      },

      getSummaries(param) {
        const {
          columns,
          data,
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
          } else if (index >= 11) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => prev + curr, 0);
            }
            console.log(column);
          }
        });
        return sums;
      },
      // deleteClick(index){
      //   this.checkTableData2.splice(index,1)
      // },
      // 导入
      importClick(index, row) {
        if (this.checkList.length < 3) return this.$message.warning('最少选择三个条件');
        this.visible = false;
        this.importShow = true;
        this.addFlag = true;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableData = val;

        let Waybill = '';
        const array = val.filter((item, index) => {
          if (index === 0) Waybill = item.portName;
          return Waybill !== item.portName;
        });
        // 筛选  供应商相同数据
        this.checkTableData = val.filter(item => Waybill === item.portName);
        let tipOne = true;
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          if (tipOne) {
            this.$message.warning('只能选择相同的供应商');
            tipOne = false;
          }
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });

        // this.$refs.accountState.calculation()
      },
      handleCurrentChangeAll(val) {
        this.checkTableData = val;
        console.log(val);
        console.log(this.checkTableData);

        // this.$refs.accountState.calculation()
      },
      tableRowClassName({ row }) {
        if (this.sumContract !== this.sumNotIncluded && this.importShow) return 'ui-warning-row';
        return '';
      },

      selectChange() { // 勾选
        // 先清空选择
        this.$refs.multipleTable.clearSelection();
        this.$nextTick(() => {
          this.checkTableData.forEach((row) => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
          });
        });
      },
      dialogClose() {
        // this.activeName = 'information';
        this.addFlag = false;// 关闭窗口
        // 清空
        // for (const informationDataKey in this.informationData) {
        //   this.informationData[informationDataKey] = '';
        // }
        // 清除提示
        // this.$refs.ruleForm.resetFields();
        // this.checkTableData =[]
      },
      calculation(table, zi) {
        let sum = 0;
        table.forEach((item, index) => {
          sum += Number(item[zi]);
          console.log(sum);
        });
        return sum;
      },
      deleteClick(index, flag) {
        if (flag === 1) {
          const array = this.checkTableData.splice(index, 1);

          array.forEach((item) => {
            this.notTableData.push(item);
          });
          console.log(this.notTableData);
          this.selectChange();
        } else {
          this.otherTableData.splice(index, 1);
          this.$refs.otherAdds.toggleSelection();
        }
      },
      otherAddClick() {
        this.consignorId = this.checkTableData.length > 0 ? this.checkTableData[0].portId : '';
        this.otherAddFlag = true;
        this.$nextTick(() => {
          this.$refs.otherAdds._othercostGetAllByCompanyId();
        });
      },
      otherData(value) {
        this.otherTableData = value;
      },
      addWaybill(index) {
        const a = this.notTableData.splice(index, 1);
        this.checkTableData.push(a[0]);
        this.selectChange();
      },
      //  判断 不/含税合同价是否为空  value  value2其他费用
      decideContract(value, value2) {
        let flag = true;
        for (const valueElement of value) {
          if (valueElement.Contract === null || valueElement.sumNotIncluded === null) {
            // 是否禁用选项
            this.isDisabled = true;
            flag = false;
            console.log(this.isDisabled);
            this.informationData.Settlement = 2;
            break;
          } else {
            flag = true;
          }
        }
        for (const value2Element of value2) {
          if (value2Element.included === null || value2Element.notIncluded === null) {
            // 是否禁用选项
            this.isDisabled = true;
            flag = false;
            console.log(this.isDisabled);
            this.informationData.Settlement = 2;
            // 终止foreach 并且不执行后面的代码
            break;
          } else {
            flag = true;
          }
        }

        if (flag) {
          this.isDisabled = false;
        }
      },
      async tableShow(index, row) {
        row.isTableExpandShow = !row.isTableExpandShow;
        // 如果为true 就请求接口获取子表格数据
        if (row.isTableExpandShow) row.children = await this._refuelingpowerVehicleAllListById(row.id);
        this.$refs.multipleTable.toggleRowExpansion(row, row.isTableExpandShow);
      },
      async tableShowWork(index, row) {
        row.isTableExpandWorkShow = !row.isTableExpandWorkShow;
        if (row.isTableExpandWorkShow) row.children = await this._refuelingpowerVehicleAllListById(row.id);
        this.$refs.checkTable.toggleRowExpansion(this.checkTableData[index], row.isTableExpandWorkShow);
      },
      // 生产对账点 确认
      accountAdd() {
        if (this.checkTableData.length <= 0) return this.$message.warning('作业费用不能为空');
        // if (this.otherTableData.length<=0) return this.$message.warning('其他费用不能为空')
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this._customerAdd();
          } else {

          }
        });
      },
      // 是否抵扣开票
      isInvoicingChange(value) {
        const id = this.checkTableData.length > 0 ? this.checkTableData[0].portId : '';
        if (value === 1) {
          this._deductionInvoicingCostGetAllByCompanyId(id);
        }
      },
      // 打开 新增/修改 弹出框
      addData() {
        this.dialogDataReset();
        this.dialogTitle = '新增';
        this.dialogVisible = true;
      },
      // 关闭 新增/修改 弹出框
      dialogShut() {
        this.$refs.addForm.resetFields();
        this.dialogVisible = false;
      },
      // 查询港口
      async _allList() {
        const res = await supplierPublicSelectPort();
        if (res.status !== 0) return this.$message.error(res.message);
        this.portOption = res.data.map(item => item);
        console.log(this.portOption);
      },
      // 新增/修改
      async addOrEdit() {
        const params = {
          ...this.addFormData,
          portOtherCarList: [],
        };
        console.log(this.dialogData);
        this.dialogData.forEach((res) => {
          params.portOtherCarList.push({ planCarId: res.id });
        });
        let data = {};
        if (this.dialogTitle === '修改') {
          data = await updateCost(params);
        } else {
          data = await addCost(params);
        }
        if (data.status === -1) {
          this.$message.error(data.message);
          return;
        }
        this.$message.success(data.message);
        this.dialogVisible = false;
        await this._refuelingpowerList();
      },
      // 新增弹出框表格数据
      async addDialogTable() {
        if (!this.dialogForm.waybillNo || !this.dialogForm.frameNumber) return this.$message.error('添加作业车需填写运单号和车架号！');
        const {
          status,
          data,
          message,
        } = await addTableData(this.dialogForm);
        if (status === -1) {
          this.$message.error(message);
          return;
        }
        if (this.dialogData.length < Number(this.addFormData.taskNum)) {
          let isRepeat = false;
          this.dialogData.forEach((res) => {
            if (data.id === res.id) {
              isRepeat = true;
            }
          });
          if (isRepeat) {
            this.$message.error('该数据已存在，请勿重复添加！');
          } else {
            this.dialogData.push(data);
            this.dialogForm = {
              waybillNo: '',
              frameNumber: '',
            };
          }
        } else {
          this.$message.error('添加作业车数量不能大于基本信息的作业测数量！');
        }
      },
      // 移除弹出框表格数据
      delDialogData(index) {
        this.dialogData.splice(index, 1);
      },
      // 根据作业类型改变消费数量单位
      changUnit() {
        this.addFormData.workType === 2 || this.addFormData.workType === 4 ? this.unit = '升' : this.unit = '度';
      },
      // 获取 dialog 数据
      async getDialogInfo(id) {
        this.detailLoading = true;
        const { data } = await dialogInfo(id);
        this.detailLoading = false;
        // 基础信息数据
        this.addFormData = data;
        this.unit = data.unit;
        // 作业车信息数据
        data.isDetailedList ? this.dialogData = data.portOtherCarList : this.dialogData = [];
        if (this.dialogTitle === '详情') {
          if (data.auditRecordList) {
            this.stepData = [];
            // 审核信息数据
            data.auditRecordList.forEach((res) => {
              const str = this.strFormat(res.status);
              const state = res.status == 3 ? 'failure' : res.status == 2 ? 'success' : '';
              this.stepData.push({
                title: res.auditorName + str,
                time: res.createTime,
                state,
                remark: res.opinion,
              });
            });
          }
          // 操作记录
          this.detailData = data.operateRecordList;
        }
      },
      // 详情
      detailClick(id) {
        this.dialogDataReset();
        this.dialogTitle = '详情';
        this.getDialogInfo(id);
        this.dialogVisible = true;
      },
      // 修改
      changeClick(id) {
        this.dialogDataReset();
        this.dialogTitle = '修改';
        this.getDialogInfo(id);
        this.dialogVisible = true;
      },
      // 重新提交数据
      async resubmitClick(id) {
        console.log(id);
      },
      // 删除
      async delClick(id) {
        this.$confirm('确认要删除数据吗！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await delCost(id);
            if (res.status !== 0) {
              this.$message.error(res.message);
              return;
            }
            this.$message.success(res.message);
            await this._refuelingpowerList();
          })
          .catch(() => {
          });
      },
      // 清空弹出框数据
      dialogDataReset() {
        this.addFormData = {
          portId: '',
          workType: '',
          workDate: '',
          taskNum: '',
          priceNum: '',
          taxRate: '',
          taxTotalPrice: '',
        };
        this.dialogData = [];
        this.stepData = [];
        this.detailData = [];
        this.dialogForm = {
          waybillNo: '',
          frameNumber: '',
        };
      },
      // 格式化审核信息状态
      strFormat(val) {
        let returnStr = '';
        switch (val) {
          case 0:
            returnStr = ' 重新发起';
            break;
          case 1:
            returnStr = ' 发起';
            break;
          case 2:
            returnStr = ' 同意';
            break;
          case 3:
            returnStr = ' 拒绝';
            break;
          case 4:
            returnStr = ' 取消审核';
            break;
          default:
            returnStr = '';
            break;
        }
        return returnStr;
      },
      // 修改台账月 -- 打开弹窗
      ledgerRevise() {
        if (!this.checkTableData.length || this.checkTableData.length == 0) return this.$message.error('请选择至少一条数据！');
        if (this.checkTableData.length > 100) return this.$message.error('最多选择100条数据！');
        this.ledgerData = this.checkTableData;
        this.ledgerVisible = true;
      },
      // 修改台账月 -- 删除
      delLedger(index) {
        this.ledgerData.splice(index, 1);
      },
      // 修改台账月 -- 确认
      async ledgerChange() {
        const params = {
          standingBookMonth: this.ledger,
          portOtherinfoList: [],
        };
        this.ledgerData.forEach((res) => {
          params.portOtherinfoList.push({ id: res.id });
        });
        await updateStandingBook(params)
          .then((res) => {
            if (res.status === 0) {
              this.$message.success(res.message);
              this.ledgerVisible = false;
              this.searchBtn();
            } else {
              this.$message.error(res.message);
            }
          });
      },
      // 修改台账月 -- 取消(关闭弹窗)
      ledgerClose() {
        this.ledger = '';
        this.ledgerData = [];
        this.ledgerVisible = false;
      },
      auditClick(id, type) {
        this.$confirm(`确认${type ? '同意' : '拒绝'}当前委托商申请吗`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.activeId = id;
            this.reason = '';
            type ? this.reasonTitle = '同意原因' : this.reasonTitle = '拒绝原因';
            this.reasonVisible = true;
          })
          .catch(() => {
          });
      },
      async reasonClick() {
        this.reason = this.reason.trim();
        if (!this.reason) return this.$message.warning(this.reasonTitle === '同意原因' ? '请填写同意原因！' : '请填写拒绝原因!');
        const res = await auditFuelCost({
          id: this.activeId,
          auditOpinion: this.reason,
          reviewResult: this.reasonTitle === '同意原因' ? 'AGREE' : 'REFUSE',
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        this.reasonVisible = false;
        await this._refuelingpowerList();
      },
      // 关闭弹窗并刷新页面
      closeDialogAndSearch() {
        this.dialogClose();
        this.searchBtn();
      },
    },
  };

</script>


<style lang='scss' scoped>
  .electrify {
    width: 100%;
    padding: 20px 15px 0 25px;
    height: 100%;

    .exportButton {
      span {
        color: rgba(51, 136, 255, 1);
        margin-right: 10px;
        font-size: 14px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      ::v-deep {
        label.el-form-item__label {
          line-height: 30px;
          font-weight: 500;
          color: #101010;
        }

        .el-form-item__content {
          line-height: 30px;
        }
      }
    }

    .content {
      ::v-deep {
        .el-table__expanded-cell {
          padding: 0;
          text-align: end;

          .el-table {
            left: 50%;
          }
        }

        .el-table__expand-icon > i {
          //display: none;
        }

        .el-table th > .cell {
          font-weight: 700 !important;
        }

      }
    }

    ::v-deep .importBill {
      width: 100%;
      padding: 10px 16px 20px 20px;

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      .el-table td, .el-table th {
        padding: 0;
      }

      .el-tabs__item.is-active {
        color: #335483
      }

      .el-tabs__item {
        font-weight: bold !important;
      }

      cell {
        font-size: 10px;
        padding: 0;
      }

      .el-table .ui-warning-row {
        background-color: #fef0f0 !important;
      }

      .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
        background-color: #fef0f0 !important;
      }

      .el-table .ui-warning-row .cell {
        color: red;
      }

      .information {
        /*width: 83%;*/
        .el-form-item__label {
          font-weight: 700;
        }

        .el-input {
          width: 56%;
        }

        .el-form-item {
          margin-bottom: 9px;
        }

        .costList {
          .el-input {
            width: 100%;
          }
        }

        .icon {
          color: red;
          font-size: 20px;
          margin-left: 20px;

          span {
            font-size: 15px;
          }
        }

      }

      .cost {
        .iconError {
          font-size: 20px;

          i:hover {
            color: #00e1ff;
          }
        }

        .el-table__expanded-cell {
          padding: 0;
          text-align: end;

          .el-table {
            left: 50%;
          }
        }

        .el-table__expand-icon > i {
          display: none;
        }

      }

      .operation {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;

          .el-button--mini {
            padding: 4px 4px;
          }
        }
      }

      .otherCost {
        .total {
          .otherAdd {
            color: rgba(51, 136, 255, 1);
            text-align: right;

            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }


  }

  ::v-deep {

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

    .el-form--inline .el-form-item {
      margin-bottom: 5px;
    }

  }

  .electrify .importBill .operation {
    margin-top: 0px !important;
    padding: 0px;
  }

  .electrify .importBill .operationTable {
    padding-right: 0px !important;
  }

  ::v-deep .add {

    .el-form-item__label {
      font-weight: 700;
    }

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    width: 100%;

    .baseInfo {
      display: flex;
      flex-direction: column;

      &Content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px 23px 0 23px;
        font-size: 14px;

        .center-f {
          display: flex;
        }

        .yang {
          margin-top: 10px;

          .el-form-item {
            .el-form-item__error {
              left: 40px;
            }

            margin-bottom: 15px;

            .el-form-item__label {
              //width: 150px !important;
              /*color: #060606;*/
            }

            .el-input {
              width: 88%;
            }

            .el-textarea {
              width: 250px;

            }
          }

        }

        .el-upload-list__item {
          width: 100px;
          height: 100px;
        }

        .el-upload--picture-card {
          width: 100px;
          height: 100px;
          line-height: 100px;
        }

        .imgUp {
          display: flex;
          flex-direction: column;

          .imgLength {
            display: flex;
            align-items: center;
            width: 100%;

            span {
              margin-left: auto;
              color: rgb(183, 183, 183);
              font-size: 16px;
            }
          }
        }
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 13px;
      margin-top: 20px;

      button {
        margin: 0 15px;
      }
    }
  }

  .el-select {
    width: 100%;
  }

  .dialogForm {
    margin-top: 14px;
  }

  .el-input-group {
    vertical-align: middle;
  }

  .ledger {
    padding: 20px;

    .leader-input {
      display: inline-block;
      width: 100%;
      margin-bottom: 15px;

      span {
        display: inline-block;
        width: 100px;
      }

      ::v-deep {
        .el-input.el-input--small {
          display: inline-block;
          width: 200px;
        }
      }
    }

    ::v-deep {
      .el-table td {
        padding: 5px;
      }

      .el-table td, .el-table th {
        font-size: 13px;
        padding: 5px;
      }
    }
  }

  .reasonContainer {
    width: 100%;
    padding: 20px 30px;

    ::v-deep {
      .el-textarea__inner {
        min-height: 100px !important;
      }
    }

    .reasonBtn {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
</style>
